import { defineStore } from 'pinia'
import { ref } from 'vue'
import { resetAuthCache } from '@/router/auth-guard'

export const useAuthStore = defineStore('auth', () => {
  const isAuthenticated = ref(false)
  const username = ref<string | null>(null)
  const isStaff = ref(false)

  const checkAuth = async () => {
    try {
      const response = await fetch('/api/auth/check/', {
        credentials: 'include'
      })
      const data = await response.json()

      isAuthenticated.value = data.authenticated
      username.value = data.username
      isStaff.value = data.is_staff

      return data.authenticated
    } catch (error) {
      console.error('Auth check failed:', error)
      isAuthenticated.value = false
      username.value = null
      isStaff.value = false
      return false
    }
  }

  const logout = async () => {
    try {
      await fetch('/api/auth/logout/', {
        method: 'POST',
        credentials: 'include'
      })

      isAuthenticated.value = false
      username.value = null
      isStaff.value = false
      resetAuthCache()
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  return {
    isAuthenticated,
    username,
    isStaff,
    checkAuth,
    logout
  }
})
